import { useAppContext } from "@/contexts/AppContext";

export type AppLayoutMode = "compact" | "workspace";

export function useAppLayout() {
  const { layoutMode, setLayoutMode } = useAppContext();

  return {
    layoutMode,
    setLayoutMode,
  } as const;
}
